import { create } from 'zustand'

const TagState = create<TagStateInterface>((set) => {
    const TagInitialState: TagStateInterface = {
        Tags: [],
        Loading: false,
        SetState: (payload: TagInterface) => set((state: TagStateInterface) => ({
            ...state,
            ...payload
        }))
    }

    return TagInitialState
})

export default TagState
